/**
 * bubu-tienda.js — tienda: filtros en cliente, desplegables, hojas móviles,
 * estado en la URL y tarjeta «Monta tu caja» estirada al hueco disponible.
 *
 * Filtros: Textura, Color y No mancha sobre los data-* que ya pinta Liquid en cada
 * tarjeta. Con ~20 productos no hace falta Search & Discovery.
 * Estado (textura, color, nm) en la URL para que sea compartible.
 * Sin scrollIntoView en ninguna parte.
 */

const tienda = document.querySelector('[data-bubu-tienda]');
if (tienda) arranca(tienda);

function arranca(root) {
  const parrilla = root.querySelector('[data-parrilla]');
  const tarjetas = () => Array.from(parrilla.querySelectorAll('[data-bubu-tarjeta]'));
  const estado = { textura: '', color: '', nm: false };

  // ---------- URL → estado ----------
  const url = new URL(window.location.href);
  estado.textura = url.searchParams.get('textura') || '';
  estado.color = url.searchParams.get('color') || '';
  estado.nm = url.searchParams.get('nm') === '1';

  function guardaURL() {
    const u = new URL(window.location.href);
    ['textura', 'color', 'nm'].forEach((k) => u.searchParams.delete(k));
    if (estado.textura) u.searchParams.set('textura', estado.textura);
    if (estado.color) u.searchParams.set('color', estado.color);
    if (estado.nm) u.searchParams.set('nm', '1');
    history.replaceState(null, '', u.toString());
  }

  // ---------- Opciones sin productos: se ocultan ----------
  // Se vuelve a pasar cada vez que cambia la parrilla (al cambiar de pestaña), así que
  // enciende y APAGA: una textura que no estaba en «Mystery» tiene que volver a salir
  // al volver a «Todos».
  function escaneaPresentes() {
    const presentes = { textura: new Set(), color: new Set() };
    tarjetas().forEach((t) => {
      if (t.dataset.textura) presentes.textura.add(t.dataset.textura);
      // Un producto puede llevar VARIOS colores (el campo de color de Shopify es una
      // lista), así que data-color viene separado por comas.
      if (t.dataset.color) t.dataset.color.split(',').forEach((c) => { if (c) presentes.color.add(c); });
    });
    ['textura', 'color'].forEach((k) => {
      document.querySelectorAll(`[data-bubu-dd="${k}"] [data-valor], [data-bubu-chips="${k}"] [data-valor]`).forEach((op) => {
        const v = op.dataset.valor;
        op.classList.toggle('is-oculta', !!v && !presentes[k].has(v));
      });
      // Si no hay ninguna opción con producto, el filtro entero se oculta.
      const vacio = presentes[k].size === 0;
      document.querySelectorAll(`[data-bubu-dd="${k}"]`).forEach((d) => (d.hidden = vacio));
      document.querySelectorAll(`[data-bubu-chips="${k}"]`).forEach((c) => {
        c.hidden = vacio;
        const lbl = c.previousElementSibling;
        if (lbl && lbl.classList.contains('bubu-hoja__label')) lbl.hidden = vacio;
      });
    });
  }
  escaneaPresentes();

  // ---------- Aplicar ----------
  function aplica() {
    let n = 0;
    tarjetas().forEach((t) => {
      let ok = true;
      if (estado.textura && t.dataset.textura !== estado.textura) ok = false;
      if (estado.color && (t.dataset.color || '').split(',').indexOf(estado.color) < 0) ok = false;
      if (estado.nm && t.dataset.noMancha !== '1') ok = false;
      t.hidden = !ok;
      if (ok) n++;
    });
    const sin = root.querySelector('[data-bubu-sin-resultados]');
    if (sin) sin.hidden = n > 0;
    document.querySelectorAll('[data-bubu-n-filtrados]').forEach((el) => (el.textContent = n));
    const nF = (estado.textura ? 1 : 0) + (estado.color ? 1 : 0) + (estado.nm ? 1 : 0);
    document.querySelectorAll('[data-bubu-n-filtros]').forEach((el) => {
      el.textContent = nF;
      el.hidden = nF === 0;
    });
    document.querySelectorAll('[data-bubu-filtro-btn]').forEach((b) => b.classList.toggle('is-activo', nF > 0));
    // Controles reflejan el estado.
    document.querySelectorAll('[data-bubu-filtro-nm]').forEach((c) => (c.checked = estado.nm));
    document.querySelectorAll('[data-bubu-nm-tarjeta]').forEach((c) => c.classList.toggle('is-sel', estado.nm));
    ['textura', 'color'].forEach((k) => {
      document.querySelectorAll(`[data-bubu-dd="${k}"] [data-valor], [data-bubu-chips="${k}"] [data-valor]`).forEach((op) => op.classList.toggle('is-sel', op.dataset.valor === estado[k]));
      document.querySelectorAll(`[data-bubu-dd="${k}"]`).forEach((dd) => {
        const btn = dd.querySelector('[data-bubu-dd-btn]');
        const lbl = dd.querySelector('[data-bubu-dd-label]');
        const sel = dd.querySelector(`[data-valor="${estado[k]}"]`);
        if (btn && lbl) {
          lbl.textContent = estado[k] && sel ? sel.textContent.trim() : btn.dataset.vacio || lbl.textContent;
          btn.classList.toggle('is-activo', !!estado[k]);
        }
      });
    });
    guardaURL();
  }

  // ---------- Eventos ----------
  document.addEventListener('change', (e) => {
    if (e.target.matches('[data-bubu-filtro-nm]')) {
      estado.nm = e.target.checked;
      aplica();
    }
  });
  document.addEventListener('click', (e) => {
    const op = e.target.closest('[data-bubu-dd="textura"] [data-valor], [data-bubu-dd="color"] [data-valor], [data-bubu-chips] [data-valor]');
    if (op) {
      const cont = op.closest('[data-bubu-dd],[data-bubu-chips]');
      const k = cont.dataset.bubuDd || cont.dataset.bubuChips;
      estado[k] = op.dataset.valor || '';
      aplica();
      cierraDd();
      return;
    }
    if (e.target.closest('[data-bubu-limpiar]')) {
      estado.textura = '';
      estado.color = '';
      estado.nm = false;
      aplica();
      return;
    }
    const btn = e.target.closest('[data-bubu-dd-btn]');
    if (btn) {
      const dd = btn.closest('[data-bubu-dd]');
      const abierto = btn.getAttribute('aria-expanded') === 'true';
      cierraDd();
      if (!abierto) {
        btn.setAttribute('aria-expanded', 'true');
        dd.querySelector('[data-bubu-dd-menu]').hidden = false;
      }
      return;
    }
    if (!e.target.closest('[data-bubu-dd]')) cierraDd();
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') cierraDd();
  });
  function cierraDd() {
    document.querySelectorAll('[data-bubu-dd-btn]').forEach((b) => b.setAttribute('aria-expanded', 'false'));
    document.querySelectorAll('[data-bubu-dd-menu]').forEach((m) => (m.hidden = true));
  }

  aplica();

  /* ==========================================================================
     PESTAÑAS SIN RECARGA
     --------------------------------------------------------------------------
     Cada pestaña es una colección distinta, o sea una URL distinta, y cambiar de
     pestaña era una recarga entera: esperar al HTML, al CSS, al JS y a los scripts de
     terceros, y aparecer de vuelta arriba del todo. Aquí se pide SOLO la sección de la
     tienda (?sections=<id real de la sección, ver más abajo>) y se cambian por dentro
     tres cosas: el kicker, la parrilla y el contador. No se
     toca la cabecera, ni el pie, ni la tarjeta de «Monta tu caja», ni las hojas
     móviles: siguen vivas, con su estado, y la página NO se mueve de sitio.

     Lo ya visto se guarda en memoria, así que volver a una pestaña es instantáneo, y
     al pasar el ratón (o el dedo) por encima se va pidiendo por adelantado. Si algo
     falla —red, respuesta rara, navegador viejo— se deja pasar el enlace y la página
     se recarga como siempre: no hay forma de quedarse sin tienda.
     ========================================================================== */
  const memoria = new Map();
  const tituloBase = (document.title.split('–').pop() || '').trim();
  let enCurso = null;

  /**
   * El id que entiende el Section Rendering API NO es «tienda».
   *
   * En una plantilla JSON, Shopify le antepone el id de la plantilla: lo que en
   * templates/collection.json se llama «tienda» viaja como
   * «template--27940815733064__tienda», y ese número cambia si la plantilla se
   * recrea. Pidiendo «tienda» a secas la respuesta era {"tienda": null}: la promesa
   * fallaba, el catch hacía window.location.href = href y la tienda acababa
   * recargándose entera —justo lo que este código existe para evitar—.
   *
   * Así que el id se lee del DOM, que es donde Shopify ya lo ha escrito: el
   * contenedor de la sección es <div id="shopify-section-NOMBRE-REAL">.
   */
  const idSeccion = (() => {
    const caja = root.closest('[id^="shopify-section-"]');
    return caja ? caja.id.replace(/^shopify-section-/, '') : 'tienda';
  })();

  function pideSeccion(href) {
    if (memoria.has(href)) return Promise.resolve(memoria.get(href));
    const u = new URL(href, window.location.origin);
    u.searchParams.set('sections', idSeccion);
    // OJO: nada de `Accept: application/json`. Con esa cabecera, Shopify contesta con
    // el JSON de la COLECCIÓN (su endpoint .json) en vez de con las secciones
    // pintadas, y la respuesta no trae ni una línea de HTML. El Section Rendering API
    // ya devuelve JSON por su cuenta.
    return fetch(u.toString())
      .then((r) => {
        if (!r.ok) throw new Error('respuesta ' + r.status);
        return r.json();
      })
      .then((j) => {
        const html = j && j[idSeccion];
        if (typeof html !== 'string' || !html) throw new Error('sección vacía');
        memoria.set(href, html);
        return html;
      });
  }

  function copiaTrozo(nueva, selector) {
    const viejo = root.querySelector(selector);
    const nuevo = nueva.querySelector(selector);
    if (viejo && nuevo) viejo.innerHTML = nuevo.innerHTML;
  }

  function aplicaSeccion(html, href) {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const nueva = doc.querySelector('[data-bubu-tienda]');
    const parrillaNueva = nueva && nueva.querySelector('[data-parrilla]');
    if (!nueva || !parrillaNueva) throw new Error('sin parrilla');

    parrilla.innerHTML = parrillaNueva.innerHTML;
    copiaTrozo(nueva, '.bubu-tienda__cab');
    copiaTrozo(nueva, '.bubu-controles__n');
    copiaTrozo(nueva, '.bubu-hoja__ok');

    // Paginación: puede aparecer, desaparecer o cambiar de enlaces.
    const pagVieja = root.querySelector('.bubu-paginacion');
    const pagNueva = nueva.querySelector('.bubu-paginacion');
    if (pagNueva && pagVieja) pagVieja.replaceWith(pagNueva.cloneNode(true));
    else if (pagNueva) parrilla.after(pagNueva.cloneNode(true));
    else if (pagVieja) pagVieja.remove();

    // La pestaña activa, en las dos filas (PC y carril móvil).
    const camino = new URL(href, window.location.origin).pathname;
    document.querySelectorAll('.bubu-pestana').forEach((a) => {
      const suya = new URL(a.getAttribute('href'), window.location.origin).pathname === camino;
      a.classList.toggle('is-activa', suya);
      if (suya) a.setAttribute('aria-current', 'page');
      else a.removeAttribute('aria-current');
      if (suya) {
        const etq = a.textContent.trim();
        if (etq) document.title = etq + (tituloBase ? ' – ' + tituloBase : '');
      }
    });
    root.dataset.coleccion = nueva.dataset.coleccion || root.dataset.coleccion;

    // Cambiar de sección es empezar de cero con los filtros: los de la anterior no
    // tienen por qué existir aquí.
    estado.textura = '';
    estado.color = '';
    estado.nm = false;
    escaneaPresentes();
    aplica();
    // Las tarjetas recién pintadas no saben qué hay ya en la caja: se lo dice el carrito.
    if (window.BubuCart && window.BubuCart.cart) window.BubuCart._contadores();
  }

  function cambiaPestana(href, empuja) {
    const ficha = { href: href };
    enCurso = ficha;
    const lento = setTimeout(() => {
      if (enCurso === ficha) parrilla.classList.add('is-cargando');
    }, 140);
    return pideSeccion(href)
      .then((html) => {
        if (enCurso !== ficha) return; // ha pulsado otra pestaña mientras tanto
        aplicaSeccion(html, href);
        if (empuja) history.pushState({ bubu: 'pestana' }, '', href);
      })
      .catch(() => {
        if (enCurso === ficha) window.location.href = href;
      })
      .then(() => {
        clearTimeout(lento);
        if (enCurso === ficha) {
          parrilla.classList.remove('is-cargando');
          enCurso = null;
        }
      });
  }

  function esPestanaUtil(a, e) {
    if (!a || !a.getAttribute('href')) return false;
    if (e && (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button > 0)) return false;
    if (a.target && a.target !== '_self') return false;
    if (!/^\/collections\//.test(new URL(a.getAttribute('href'), window.location.origin).pathname)) return false;
    return true;
  }

  document.addEventListener('click', (e) => {
    const a = e.target.closest('.bubu-pestana');
    if (!esPestanaUtil(a, e)) return;
    e.preventDefault();
    const href = a.getAttribute('href');
    if (new URL(href, window.location.origin).pathname === window.location.pathname) return;
    // La pestaña se marca YA: el cambio se siente al soltar el dedo, no al llegar el HTML.
    cierraDd();
    cambiaPestana(href, true);
  });

  // Se va pidiendo por adelantado en cuanto el dedo o el ratón rozan la pestaña.
  ['pointerenter', 'touchstart'].forEach((ev) => {
    document.addEventListener(
      ev,
      (e) => {
        const a = e.target && e.target.closest ? e.target.closest('.bubu-pestana') : null;
        if (!esPestanaUtil(a, null)) return;
        const href = a.getAttribute('href');
        if (new URL(href, window.location.origin).pathname === window.location.pathname) return;
        pideSeccion(href).catch(() => {});
      },
      { capture: true, passive: true }
    );
  });

  window.addEventListener('popstate', () => {
    const camino = window.location.pathname;
    if (!/^\/collections\//.test(camino)) return; // fuera de la tienda: que navegue el navegador
    cambiaPestana(camino + window.location.search, false);
  });

  // ---------- Puente a cumples (8 Bubus o más) ----------
  document.addEventListener('bubu:cart', (e) => {
    const puente = root.querySelector('[data-bubu-puente]');
    if (!puente) return;
    const caja = document.querySelector('[data-bubu-caja]');
    const uds = caja ? Number(caja.dataset.uds || 0) : 0;
    puente.hidden = uds < 8;
  });

  // ---------- «Monta tu caja»: se estira al hueco disponible (README) ----------
  const rail = root.querySelector('[data-bubu-rail]');
  if (rail) {
    let raf = 0;
    const mide = () => {
      raf = 0;
      if (window.innerWidth < 820) return;
      const r = rail.getBoundingClientRect();
      const top = Math.max(r.top, 84) + 24; // padding-top de la columna
      const libre = window.innerHeight - top - 24;
      const h = Math.max(420, Math.min(900, libre, window.innerHeight - 112));
      rail.style.setProperty('--bubu-caja-h', h + 'px');
    };
    const pide = () => {
      if (!raf) raf = requestAnimationFrame(mide);
    };
    window.addEventListener('scroll', pide, { passive: true });
    window.addEventListener('resize', pide);
    document.addEventListener('bubu:seccion-repintada', pide);
    mide();
  }

  // ---------- Nunca se añade a ciegas: el hueco recién llenado queda visible ----------
  // Lo avisa bubu-cart.js en el mismo instante en que nace la casilla (bubu:slot-nuevo),
  // no el repintado del servidor. Antes se colgaba de la respuesta de Shopify: el Bubu
  // aparecía al tocar y medio segundo después llegaban el pop y el desplazamiento, así
  // que una sola acción se veía como dos cosas sueltas. El pop también se ha ido a
  // bubu-cart.js, que es donde dice su cabecera que viven las animaciones de añadir;
  // aquí se queda solo lo que es de la tienda: llevar la mirada al hueco.
  document.addEventListener('bubu:slot-nuevo', (e) => {
    const slot = e.detail && e.detail.slot;
    if (!slot || !slot.closest) return;
    const scroll = slot.closest('[data-bubu-slots-scroll]');
    if (!scroll) return;
    const sr = scroll.getBoundingClientRect();
    const r = slot.getBoundingClientRect();
    if (!r.height || !sr.height) return;
    if (r.top >= sr.top && r.bottom <= sr.bottom) return; // ya se veía: no se mueve
    const destino = scroll.scrollTop + (r.top - sr.top) - (sr.height - r.height) / 2;
    scroll.scrollTo({ top: Math.max(0, destino), behavior: 'smooth' });
  });

  // ---------- Huecos vacíos y «Elige tu primer Bubu» → tira de packs ----------
  document.addEventListener('click', (e) => {
    const a = e.target.closest('[data-bubu-slot-vacio], [data-bubu-caja-btn].is-vacio');
    if (!a) return;
    e.preventDefault();
    const packs = document.querySelector('[data-packs]:not([style*="display: none"])');
    const destino = Array.from(document.querySelectorAll('[data-packs]')).find((p) => p.offsetParent !== null) || packs;
    if (!destino) return;
    const cab = document.querySelector('.bubu-seccion-cabecera');
    const offset = (cab ? cab.getBoundingClientRect().height : 72) + 16;
    const y = destino.getBoundingClientRect().top + window.scrollY - offset;
    desplazaControlado(y);
  });
}

/** Desplazamiento controlado: se aborta si el usuario toca la rueda o arrastra. */
function desplazaControlado(y) {
  let cancelado = false;
  const cancela = () => {
    cancelado = true;
  };
  window.addEventListener('wheel', cancela, { once: true, passive: true });
  window.addEventListener('touchstart', cancela, { once: true, passive: true });
  const y0 = window.scrollY;
  const dist = y - y0;
  const dur = Math.min(700, Math.max(260, Math.abs(dist) * 0.6));
  const t0 = performance.now();
  const ease = (t) => 1 - Math.pow(1 - t, 3);
  function paso(t) {
    if (cancelado) return;
    const p = Math.min(1, (t - t0) / dur);
    window.scrollTo(0, y0 + dist * ease(p));
    if (p < 1) requestAnimationFrame(paso);
    else {
      window.removeEventListener('wheel', cancela);
      window.removeEventListener('touchstart', cancela);
    }
  }
  requestAnimationFrame(paso);
}
window.bubuDesplaza = desplazaControlado;

/* =========================================================
   La primera vez que llegas a la tienda con algo ya dentro
   ---------------------------------------------------------
   Caso real: alguien añade su primer Bubu desde la ficha de producto. Ahí el paso de 0
   a 1 abre el carrito y se entera de todo. Pero si añade desde la ficha y DESPUÉS entra
   en la tienda, en la tienda ya no hay paso de 0 a 1: la caja se queda abajo, cerrada,
   y esa persona no sabe que existe ni que hay tramos de descuento esperándola.

   Así que la caja se abre sola UNA vez, y solo cuando se cumple todo esto:
     · estamos en la tienda (este archivo solo se carga aquí; en la ficha no se hace:
       abrirle una hoja encima del producto a quien acaba de llegar es secuestrarle la
       pantalla),
     · en móvil (en PC la caja ya está a la vista, pegada en la columna derecha),
     · ya lleva algo dentro (si está vacía no hay nada que enseñar),
     · no la ha visto todavía en esta visita,
     · y sigue arriba del todo, recién llegado: si ya está bajando, está mirando otra
       cosa y no se le interrumpe.

   «Vista» se marca también cuando la abre él, o cuando abre el carrito: en los dos
   casos ya sabe que existe. La marca vive en sessionStorage, así que es por visita y no
   se queda pegada para siempre.
   ========================================================= */
(() => {
  const CLAVE = 'bubu:caja-vista';
  const marca = () => {
    try {
      sessionStorage.setItem(CLAVE, '1');
    } catch (e) {
      /* navegación privada: sin marca, pero tampoco se abre (leer también falla) */
    }
  };
  const yaVista = () => {
    try {
      return sessionStorage.getItem(CLAVE) === '1';
    } catch (e) {
      return true;
    }
  };

  document.addEventListener('bubu:abrir', (e) => {
    const id = e.target && e.target.id;
    if (id === 'bubu-hoja-caja' || id === 'bubu-cesta') marca();
  });

  const quizaAbre = () => {
    if (yaVista()) return;
    if (!matchMedia('(max-width: 819.98px)').matches) return;
    if (window.scrollY > 240) return;
    const caja = document.querySelector('[data-bubu-caja]');
    if (!caja || Number(caja.dataset.n || 0) < 1) return;
    const hoja = document.getElementById('bubu-hoja-caja');
    if (!hoja || typeof hoja.abrir !== 'function') return;
    marca();
    hoja.abrir();
  };

  // 900 ms: lo justo para que la tienda haya pintado y no parezca que la hoja se abre
  // antes que la propia página.
  const arranca = () => setTimeout(quizaAbre, 900);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arranca);
  else arranca();
})();
